/**
 * SessionLicenseBuilderButton Component
 */

import { licenseUsagesToSearchParams } from '../../../../redux/helpers/license';

import * as React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { QueryStringContext } from '../../../../contexts/queryString';
import { licenseUsagesFromQueryStringSelector } from '../../../../contexts/queryString/selectors';
import { IQueryStringContext } from '../../../../contexts/queryString/types';
import { ButtonProps } from '../Button';
import LicenseBuilderButton, { LicenseBuilderButtonProps } from './';

interface IOwnStateProps {
  usages: ILicenseUsage[];
}

interface IOwnProps extends Pick<IQueryStringContext, 'license_params' | 'removeLicense' | 'saveLicense'> {
  onSaveLicense?: LicenseBuilderButtonProps['onSaveLicense'];
  onOpenLicenseBuilder?: () => any;
  onCloseLicenseBuilder?: () => any;
}

type AllowedLicenseBuilderProps =
  & Pick<IOwnProps, 'onSaveLicense' | 'onOpenLicenseBuilder' | 'onCloseLicenseBuilder'>
  & Pick<LicenseBuilderButtonProps, 'selectedUsage' | 'stopPropagation'>
  & ButtonProps;

export type ExposedSessionLicenseBuilderButtonProps = AllowedLicenseBuilderProps;

type SessionLicenseBuilderButtonProps =
  & DispatchProp
  & IOwnProps
  & IOwnStateProps
  & AllowedLicenseBuilderProps;

class SessionLicenseBuilderButton extends React.Component<SessionLicenseBuilderButtonProps> {
  onSaveLicense = (usages: ILicenseUsage[]) => {
    if (usages.length > 0) {
      this.props.saveLicense(licenseUsagesToSearchParams(usages));
    } else {
      this.props.removeLicense();
    }

    if (!!this.props.onSaveLicense) {
      this.props.onSaveLicense(usages);
    }

    if (this.props.onCloseLicenseBuilder) {
      this.props.onCloseLicenseBuilder();
    }
  }

  render() {
    const {
      dispatch,
      license_params,
      onSaveLicense: unusedOnSaveLicense,
      removeLicense,
      saveLicense,
      ...buttonProps
    } = this.props;

    return (
      <LicenseBuilderButton
        onSaveLicense={this.onSaveLicense}
        onOpenLicenseBuilder={this.props.onOpenLicenseBuilder}
        onCloseLicenseBuilder={this.props.onCloseLicenseBuilder}
        scope={{ type: 'Session' }}
        {...buttonProps}
      />
    );
  }
}

const ConnectedSessionLicenseBuilderButton =
  connect<IOwnStateProps, {}, IOwnProps & AllowedLicenseBuilderProps, IStoreState>(
  (state, ownProps) => ({
    usages: licenseUsagesFromQueryStringSelector(state, ownProps),
  }),
)(SessionLicenseBuilderButton);

const SessionLicenseBuilderButtonWithContext: React.SFC<AllowedLicenseBuilderProps> = (props) => (
  <QueryStringContext.Consumer>
    {({ license_params, removeLicense, saveLicense }) => (
      <ConnectedSessionLicenseBuilderButton
        license_params={license_params}
        removeLicense={removeLicense}
        saveLicense={saveLicense}
        {...props}
      />
    )}
  </QueryStringContext.Consumer>
);

export default SessionLicenseBuilderButtonWithContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/buttons/LicenseBuilderButton/SessionLicenseBuilderButton.tsx